{
   "BANNER": {
    "TITLE": "Healthcare, Simplified!",
    "DESCRIPTION": "Nationwide access for your convenience.",
    "strong-1" : "Office Visits",
    "li1": "Make appointments with local clinics and pay discounted rates at the time of service.",
     "strong-2"  : "Labs & Imaging",
     "li2": "Enjoy 50%+ savings on labs and imaging services to gain insights into your health.",
     "strong-3" : "Procedures & Surgeries:",
     "li3" : " Discounted bundled services--a single price without the confusion!",
     "strong-4" : "Medications:",
     " li4" : "Expert guidance via secure messaging with a wide range of providers."
  },
  "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "Is WoW Health healthcare insurance?",
                "description": "No, WoW Health is not traditional health insurance. We're a portable membership plan that connects you with a network of healthcare providers at discounted rates. This means you can manage your health on your own terms, without being tied down to a specific employer plan."
            },
            {
                "title": "How can WoW Health accommodate my unpredictable work hours?",
                "description": "While we can't control your scheduling, WoW Health offers telemedicine options. With 24/7 access to doctors for minor injuries, illnesses, and prescriptions, you can receive care whenever it's most convenient for you. You can even get our services during your work breaks."
            },
            {
                "title" :"Are there discounts available for medical procedures and tests?",
                "description" : "Yes! WoW Health offers significant discounts: 75% off imaging, 60% off lab work, and 50% off medical procedures. Additionally, we provide 400 medications at no cost and discounts on additional medications."
 
            },
            {
                "title" : " How can I find a healthcare provider within the WoW Health network?",
                "description" : " You can access a wide network of healthcare providers, including over 350k doctors, 5k+ surgery centers, and 2100+ labs. Simply use our platform to search for and connect with providers that fit your needs."
            }
         ]
    },
  "language": "en"
}